"use client";

import type { AlgoliaProductCard, ProductCard } from "@raumagarn/formatters";
import type { ProductCardProps } from "~/features/products/ProductCard/ProductCard";
import { Tags } from "~/features/products/ProductCard/parts/Tags/Tags";
import { getProductTag } from "~/features/products/utils";
import { useCurrency } from "~/lib/hooks/useCentra";

export const ProductCardTags = ({ productCard }: ProductCardProps) => {
	const { data: currency } = useCurrency();

	return (
		<Tags activeTag={getProductTag(productCard as ProductCard | AlgoliaProductCard, currency)} />
	);
};
